import { useEffect } from 'react'
import { UseQueryResult, useQuery } from '@tanstack/react-query'
import { set } from 'idb-keyval'
import { omit } from 'lodash'
import { useDispatch } from 'react-redux'

import { GetMapByIdResults, getMapById } from '~map-preview/api/getMapById'
import { setMapData, useIsMapSaved } from '~map-preview/states/map'
import { useMapSettingsStore } from '~map-preview/states/mapSettings'
import { useMapToolbarStore } from '~map-preview/states/mapToolbar'

export const getMapByIdQueryKey = (mapId: string) => ['getMapById', mapId]

export const useGetMapById = (mapId: string) => {
  const { setDefaultVisualization } = useMapSettingsStore()
  const { setVisualization } = useMapToolbarStore()
  const dispatch = useDispatch()
  const { data: map } = useGetMap(mapId)
  useEffect(() => {
    if (map) {
      const fetchMap = async () => {
        dispatch(setMapData(map))

        const persistMap = omit(map, ['liked'])
        await set(mapId, persistMap)

        const defaultVisualization = map.defaultVisualization
          ? Object.entries(map.defaultVisualization)
              .filter(([key, value]) => value !== null)
              .reduce((acc, [key, value]) => {
                acc[key] = value
                return acc
              }, {})
          : {}

        setDefaultVisualization(defaultVisualization)
        setVisualization(defaultVisualization)
      }

      fetchMap()
    }
  }, [map])
}

function useGetMap(mapId: string): UseQueryResult<GetMapByIdResults> {
  const query = useQuery({
    enabled: true,
    queryKey: getMapByIdQueryKey(mapId),
    queryFn: async () => {
      return await getMapById({ id: mapId })
    }
  })

  return query
}
